export default
{
  dev : process.env.NODE_ENV === 'development' ? true : false,
  ///	socket请求地址
  wsurl : process.env.NODE_ENV === 'development' ? 'ws://127.0.0.1:1102' : 'wss://api.8612345.cn/rtm',

  ///	api请求地址1(PHP)1
  // host1 : process.env.NODE_ENV === 'development' ? '//localhost:8081' : '',
  host1 : process.env.NODE_ENV === 'development' ? '' : 'https://www.nmgscnyjt.com',

  ///	api请求地址2(PYTHON)
  host2 : process.env.NODE_ENV === 'development' ? 'https://dev.8612345.cn' : '//v5api.8612345.cn',

  ///	缓存前缀
  prefix : 'TSB_',

  ///	屏幕的宽高
  width : document.body.offsetWidth,
  height : screen.availHeight,

  ///	开发测试token
  // token : `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiIiLCJhdWQiOiIiLCJpYXQiOjE2NzcxMTQzMDIsImV4cCI6MTY3OTcwNjMwMiwibWlkIjoiNDczNjMzIiwiemh1ZHciOiIyMTYxIiwibWlkX19ja01kNSI6ImRmYjlkZTA0NDUxOTk4ZjQifQ.Bx43orT0X235VsHFQz_xTyLffgwyf30jxKj0RpDuozI`,
  token : localStorage.getItem( 'newToken' )?localStorage.getItem( 'newToken' ):''
}



// WEBPACK FOOTER //
// ./src/common/config.ts